/**
 * 결제 관리 API
 * OpenAPI Generator로 생성된 타입을 사용하며, 기존 Axios 인스턴스와 통합
 */
export class PaymentService {
    constructor(axiosInstance) {
        Object.defineProperty(this, "axios", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.axios = axiosInstance;
    }
    /**
     * 결제내역 조회
     * 거래 > 거래내역 > 결제내역 조회시 사용한다.
     * @param request - 결제내역 조회 요청 데이터
     * @returns 결제내역 조회 결과
     */
    getPaymentHistory(request) {
        return this.axios.get(`/main/v1/payments/history`, {
            params: request,
        });
    }
}
//# sourceMappingURL=payment.service.js.map